module.exports = __webpack_public_path__ + "static/media/consultancy.2bb9aefd.png";